import type { DimensionTab, ComparisonPreset, DrillDownGranularity } from './types';

export const DEFAULT_DIMENSION_TABS: DimensionTab[] = [
  { id: 'supplier', key: 'Fornecedor', label: 'Por Fornecedor', icon: '' },
  { id: 'client', key: 'Cliente', label: 'Por Cliente', icon: '' },
  { id: 'category', key: 'CategoriaGerencial', label: 'Por Categoria', icon: '' },
  { id: 'nature', key: 'Natureza', label: 'Por Natureza', icon: '' },
  { id: 'cost-center', key: 'CentroResultado', label: 'Por Centro', icon: '' },
  { id: 'job', key: 'Job', label: 'Por Job', icon: '' },
  { id: 'month', key: '_month', label: 'Por Mes', icon: '' },
  { id: 'day', key: '_day', label: 'Por Dia', icon: '' },
  { id: 'transactions', key: null, label: 'Transacoes', icon: '' },
];

export const COMPARISON_PRESETS: { value: ComparisonPreset; label: string }[] = [
  { value: 'none', label: 'Sem comparacao' },
  { value: 'previous_period', label: 'Periodo anterior' },
  { value: 'previous_year', label: 'Mesmo periodo ano anterior' },
];

// Presets to show in dropdown (includes 'none' to allow disabling)
export const COMPARISON_DROPDOWN_OPTIONS = COMPARISON_PRESETS;

export const GRANULARITY_OPTIONS: { value: DrillDownGranularity; label: string }[] = [
  { value: 'accumulated', label: 'Acumulado' },
  { value: 'yearly', label: 'Por Ano' },
  { value: 'quarterly', label: 'Por Trimestre' },
  { value: 'monthly', label: 'Por Mes' },
];

// Metric/Dimension labels for display (plural form for chart captions)
// Includes 'total' and 'count' as special metrics
export const METRIC_LABELS: Record<string, string> = {
  total: 'Valor Total',
  count: 'Registros',
  Fornecedor: 'Fornecedores',
  Cliente: 'Clientes',
  CategoriaGerencial: 'Categorias',
  Natureza: 'Naturezas',
  CentroResultado: 'Centros',
  Job: 'Jobs',
};

// Dimension colors for chart series (dark theme)
export const DIMENSION_COLORS = [
  '#D2FA52', // Monumenta Green (primary)
  '#a3e635', // lime-400
  '#fb923c', // orange-400
  '#c084fc', // purple-400
  '#f87171', // red-400
  '#22d3d4', // cyan-400
  '#f472b6', // pink-400
];

// Chart layout constants
export const CHART_CONSTANTS = {
  MAX_PERIODS: 50,
  DEFAULT_HEIGHT: 220,
  PADDING: {
    LEFT: 70,
    RIGHT_DEFAULT: 20,
    RIGHT_WITH_LEGEND: 120,
    RIGHT_DUAL_AXIS: 70,
    TOP: 20,
    BOTTOM_DEFAULT: 50,
    BOTTOM_WITH_COMPARISON: 70,
  },
  BAR_WIDTH: {
    SINGLE: 35,
    COMPARISON: 50,
    METRIC: 60,
  },
  GRID_PERCENTAGES: [0, 0.25, 0.5, 0.75, 1],
  COLORS: {
    CURRENT: '#D2FA52',      // Monumenta Green (primary)
    COMPARISON: '#6B7280',   // gray-500 (muted for comparison)
    POSITIVE: '#4ade80',     // green-400
    NEGATIVE: '#ef4444',     // red-500
    GRID: '#2A2D34',         // dark theme grid
    LABEL: '#838998',        // secondary text
    LEFT_AXIS: '#D2FA52',    // Monumenta Green
    RIGHT_AXIS: '#4ade80',   // green-400
  },
} as const;

// Granularity display labels (Portuguese)
export const GRANULARITY_LABELS: Record<string, string> = {
  accumulated: 'Acumulado',
  yearly: 'Por Ano',
  quarterly: 'Por Trimestre',
  monthly: 'Por Mes',
  weekly: 'Por Semana',
  daily: 'Por Dia',
};

// Month abbreviations (Portuguese)
export const MONTH_NAMES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
